"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var Slider_1 = __importDefault(require("shared/components/Slider"));
var StyledSlider = (0, styles_1.styled)(Slider_1.default)({
    '.MuiTabs-flexContainer': { alignItems: 'flex-end' },
    '& button': {
        margin: 0,
        fontSize: '12px',
        padding: '0 4px',
    },
    '.MuiTab-root': {
        '&:first-child': {
            marginLeft: 0,
            width: '100%',
        },
        '&:last-child': {
            marginRight: 0,
            width: '100%',
        },
    },
});
var CalendarSlider = function (props) { return (0, jsx_runtime_1.jsx)(StyledSlider, __assign({}, props)); };
exports.default = (CalendarSlider);
